module.exports = __webpack_public_path__ + "static/media/bg27.4a5b502c.jpg";